import React, { useEffect, useState } from "react";
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css";
import useHomeLinkMode from "../../../shared/hooks/useHomeLinkMode";
import useMobile from "../../../shared/hooks/useMobile";
import imgDivisor from "./../../../shared/assets/images/divider-02.svg";
import './filter-products.scss';

// import SEO from "../shared/components/atoms/seo/seo"

const FilterProducts = ({ filters, active, products, setProducts }) => {
    const mobile = useMobile();
    const { homeLink } = useHomeLinkMode();
    const filterEdadDeTuPequenin = filters.filter(filter => filter.slug === active)[0].edadDeTuPequenin;

    const [weightPequenin, setWeightPequenin] = useState(null);
    // const [weightPequenin, setWeightPequenin] = useState(filterEdadDeTuPequenin ? filterEdadDeTuPequenin[0].subcategorias : null);
    // const [age, setAge] = useState(filterEdadDeTuPequenin ? filterEdadDeTuPequenin[6].nombreDeLaCategoria : null);
    const [age, setAge] = useState(null);
    const [weight, setWeight] = useState();

    const [activeMobileFilters, setActiveMobileFilters] = useState(false);
    const [pageload, setPageload] = useState(false);

    useEffect(() => {
        setPageload(true)
        if (weightPequenin) {
            setWeight(parseInt(weightPequenin[0].nombreDeLaCategoria.replace('kg', '')))
            let filterProductsWeight = products.filter(product =>
                product.pesoPequenin ? product.pesoPequenin.find(element => element.nombreDeLaCategoria === weightPequenin[0].nombreDeLaCategoria) : true);
            setProducts(filterProductsWeight)
        } else {
            setProducts(products)
        }

        window.addEventListener('scroll', function (ev) {
            let element = document.getElementById('f-m-filter-products')
            const elementOffset = element.getBoundingClientRect().top
            if (elementOffset < 80) {
                element.classList.add("f-m-filter-products__float")
            } else {
                element.classList.remove("f-m-filter-products__float")
            }

        });
        let element = document.getElementById('f-m-filter-products')
        let elementOffset = element.getBoundingClientRect().top
        if (elementOffset < 80) {
            element.classList.add("f-m-filter-products__float")
        } else {
            element.classList.remove("f-m-filter-products__float")
        }
    }, [])

    const changeAge = (ageValue) => {
        if (ageValue) {
            let filterFilters = filterEdadDeTuPequenin.filter(filter => filter.nombreDeLaCategoria === ageValue)[0].subcategorias;
            setWeight(parseInt(filterFilters[0].nombreDeLaCategoria.replace('kg', '')))
            setWeightPequenin(filterFilters)
            let filterProductsAge = products.filter(product =>
                product.pesoPequenin ? product.pesoPequenin.find(element => element.nombreDeLaCategoria === filterFilters[0].nombreDeLaCategoria) : true);
            setProducts(filterProductsAge)
        } else {
            setProducts(products)
            setWeightPequenin(null)
        }
        setAge(ageValue)
    }
    const changeWeight = (weightValue) => {
        let filterProductsAge = products.filter(product =>
            product.pesoPequenin ? product.pesoPequenin.find(element => parseInt(element.nombreDeLaCategoria.replace('kg', '')) === weightValue) : true);
        setProducts(filterProductsAge)
        setWeight(weightValue)
    }
    const openModal = () => {
        document.documentElement.style.overflow = 'hidden';
        document.body.scroll = "no";
        setActiveMobileFilters(true)
    }
    const closeModal = () => {
        let element = document.getElementById('f-m-filter-products__mobile-modal')
        if (element) {
            element.classList.add("f-m-filter-products__mobile-modal-hidden")
            setTimeout(function () {
                element.classList.remove("f-m-filter-products__mobile-modal-hidden")
                if (mobile) {
                    document.documentElement.style.overflow = 'scroll';
                    document.body.scroll = "yes";
                }
                setActiveMobileFilters(false);
            }, 200);
        } else {
            setActiveMobileFilters(false);
        }



    }

    return (
        <div className="f-m-filter-products" id="f-m-filter-products">
            {mobile &&
                <>
                    <div className="f-m-filter-products__mobile-filters">
                        {filters && filters.map(
                            (filter, index) => {
                                return <a href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + filter.slug}
                                    className={"f-m-filter-products__filter-item " + (filter.slug === active ? "f-m-filter-products__filter-item-active" : "")} key={index}>
                                    <div className="f-m-filter-products__info">
                                        <p>{filter.nombreCategoria}</p>
                                    </div>

                                </a>
                            }
                        )}
                    </div>
                    {filterEdadDeTuPequenin && <p onClick={openModal} className="f-m-filter-products__mobile-text">Ver filtros</p>}
                </>
            }
            {(!mobile || activeMobileFilters) && <div className={pageload ? "f-m-filter-products__mobile-modal" : "f-m-filter-products__pre-mobile-modal"} id="f-m-filter-products__mobile-modal">
                <span className="icon icon-ico-x f-m-filter-products__mobile-modal-close" onClick={closeModal}></span>

                <div className="f-m-filter-products__header">
                    <p>Filtrar por:</p>
                    <a href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + filters[0].slug} >Borrar filtros</a>
                </div>
                <img className="f-m-filter-products__divisor" src={imgDivisor} alt="divisor" />
                {!mobile && <div className="f-m-filter-products__filter01">
                    <p className="f-m-filter-products__filter-title">Tipo de producto</p>
                    {filters && filters.map(
                        (filter, index) => {
                            return <a href={homeLink + (process.env.ENVIRONMENT === 'LOCAL' ? "" : "productos/") + filter.slug}
                                className={"f-m-filter-products__filter-item " + (filter.slug === active ? "f-m-filter-products__filter-item-active" : "")} key={index}>
                                <div className="f-m-filter-products__inner"></div>
                                <div className="f-m-filter-products__info">
                                    {/* <span className={"f-m-filter-products__info-ico icon icon-" + filter.iconoCategoria} /> */}
                                    <p>{filter.nombreCategoria}</p>
                                </div>

                            </a>
                        }
                    )}
                </div>}
                {/* {filterEdadDeTuPequenin && <div className="f-m-filter-products__filter02">
                    <p className="f-m-filter-products__filter-title">Edad de tu pequeñín</p>
                    <p className="f-m-filter-products__filter-message">Escoge la edad y el peso de tu pequeñín para encontrar la etapa ideal</p>
                    {filterEdadDeTuPequenin.map(
                        (filter, index) => {
                            return <div className={"f-m-filter-products__filter-item " + (filter.nombreDeLaCategoria === age ? "f-m-filter-products__filter-item-active" : "")}
                                key={index} onClick={() => changeAge(filter.nombreDeLaCategoria)}>
                                <div className="f-m-filter-products__inner"></div>
                                <div className="f-m-filter-products__info">
                                    <span className={"f-m-filter-products__info-ico icon icon-" + filter.iconoCategoria} />
                                    <p>{filter.nombreDeLaCategoria}</p>
                                </div>

                            </div>
                        }
                    )}
                    {process.env.LOCALE !== "es-CO" && process.env.LOCALE !== "es-EC" &&
                    (<div className={"f-m-filter-products__filter-item " + (null === age ? "f-m-filter-products__filter-item-active" : "")}
                        onClick={() => changeAge(null)}>
                        <div className="f-m-filter-products__inner"></div>
                        <div className="f-m-filter-products__info">
                            <p>Todos los pañales</p>
                        </div>
                    </div>)
                    }
                </div>} */}
                {/* {weightPequenin && <div className="f-m-filter-products__filter03">
                    <p className="f-m-filter-products__filter-title">Peso de tu pequeñín</p>
                    <InputRange
                        formatLabel={value => `${value}kg`}
                        maxValue={parseInt(weightPequenin[weightPequenin.length - 1].nombreDeLaCategoria.replace('kg', ''))}
                        minValue={parseInt(weightPequenin[0].nombreDeLaCategoria.replace('kg', ''))}
                        value={weight ? weight : parseInt(weightPequenin[0].nombreDeLaCategoria.replace('kg', ''))}
                        onChange={value => changeWeight(value)} />
                </div>} */}

            </div>}

        </div>
    )

}

export default FilterProducts